import script from "./MessageSearchTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageSearchTab.vue?vue&type=script&lang=ts&setup=true"

import "./MessageSearchTab.vue?vue&type=style&index=0&id=ddc93358&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc93358"]])

export default __exports__